export const FETCH_ATTENTION_POINTS_REQUEST = 'ATTENTION_POINTS/FETCH_REQUEST';
export const FETCH_ATTENTION_POINTS_SUCCESS = 'ATTENTION_POINTS/FETCH_SUCCESS';
export const FETCH_ATTENTION_POINTS_FAILURE = 'ATTENTION_POINTS/FETCH_FAILURE';
export const FETCH_ATTENTION_POINTS_START_POLLING = 'ATTENTION_POINTS/FETCH/START_POLLING';
export const FETCH_ATTENTION_POINTS_STOP_POLLING = 'ATTENTION_POINTS/FETCH/STOP_POLLING';

export const SHOW_ATTENTION_POINTS_PANEL = 'ATTENTION_POINTS/DRAWER/SHOW';
export const HIDE_ATTENTION_POINTS_PANEL = 'ATTENTION_POINTS/DRAWER/HIDE';

export const FETCH_APPOINTMENTS_REQUEST = 'APPOINTMENTS/FETCH_REQUEST';
export const FETCH_APPOINTMENTS_SUCCESS = 'APPOINTMENTS/FETCH_SUCCESS';
export const FETCH_APPOINTMENTS_FAILURE = 'APPOINTMENTS/FETCH_FAILURE';

export const FETCH_APPOINTMENT_REQUEST = 'APPOINTMENT/FETCH_REQUEST';
export const FETCH_APPOINTMENT_SUCCESS = 'APPOINTMENT/FETCH_SUCCESS';
export const FETCH_APPOINTMENT_FAILURE = 'APPOINTMENT/FETCH_FAILURE';

export const POST_REQUEST = 'APPOINTMENT/POST_REQUEST';
export const POST_SUCCESS = 'APPOINTMENT/POST_SUCCESS';
export const POST_FAILURE = 'APPOINTMENT/POST_FAILURE';

export const READ_MESSAGES = 'APPOINTMENT/READ_MESSAGES_REQUEST';
export const READ_MESSAGES_SUCCESS = 'APPOINTMENT/READ_MESSAGES_SUCCESS';

export const DELETE_REQUEST = 'APPOINTMENT/DELETE_REQUEST';
export const DELETE_SUCCESS = 'APPOINTMENT/DELETE_SUCCESS';
export const DELETE_FAILURE = 'APPOINTMENT/DELETE_FAILURE';

export const PUT_REQUEST = 'APPOINTMENT/PUT_REQUEST';
export const PUT_SUCCESS = 'APPOINTMENT/PUT_SUCCESS';
export const PUT_FAILURE = 'APPOINTMENT/PUT_FAILURE';

export const PATCH_STATUS_REQUEST = 'APPOINTMENT/STATUS/PATCH_REQUEST';
export const PATCH_STATUS_SUCCESS = 'APPOINTMENT/STATUS/PATCH_SUCCESS';
export const PATCH_STATUS_FAILURE = 'APPOINTMENT/STATUS/PATCH_FAILURE';

export const SET_SELECTED_ID = 'APPOINTMENT/SET_SELECTED_ID';
export const APPLICATION_IS_READY = 'APPOINTMENT/APPLICATION_IS_READY';
export const OPEN_BOOKING_MODAL = 'APPOINTMENT/MODAL/BOOKING/OPEN';
export const CLOSE_BOOKING_MODAL = 'APPOINTMENT/MODAL/BOOKING/CLOSE';

export const FETCH_SHARE_LINK = 'APPOINTMENT/FETCH_SHARE_LINK_REQUEST';
export const FETCH_SHARE_LINK_SUCCESS = 'APPOINTMENT/FETCH_SHARE_LINK_SUCCESS';
export const FETCH_SHARE_LINK_FAILURE = 'APPOINTMENT/FETCH_SHARE_LINK_FAILURE';

export const SET_PAGE_SIZE = 'APPOINTMENTS/SET_PAGE_SIZE';
export const CLEAR_PAGE = 'APPOINTMENTS/CLEAR_PAGE';

// Filter actions
export const SET_APPOINTMENT_FILTER = 'APPOINTMENTS/SET_FILTER';
export const SET_APPOINTMENT_FILTERS = 'APPOINTMENTS/SET_FILTERS';
export const CLEAR_APPOINTMENT_FILTERS = 'APPOINTMENTS/CLEAR_FILTERS';
export const REMOVE_APPOINTMENT_FILTER = 'APPOINTMENTS/REMOVE_FILTER';

export const NAVIGATE_TO_DETAILS = 'APPOINTMENTS/NAVIGATE_TO_DETAILS';

export const PERSISTED_ACTION_TYPES = [SET_APPOINTMENT_FILTER, SET_APPOINTMENT_FILTERS, CLEAR_APPOINTMENT_FILTERS, REMOVE_APPOINTMENT_FILTER];

export const FETCH_EVENTS = 'APPOINTMENTS/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'APPOINTMENTS/FETCH_EVENTS_SUCCESS';

export const FETCH_INTERVENTION = 'APPOINTMENTS/FETCH_INTERVENTION_REQUEST';
export const FETCH_INTERVENTION_SUCCESS = 'APPOINTMENTS/FETCH_INTERVENTION_SUCCESS';
export const FETCH_INTERVENTION_FAILURE = 'APPOINTMENTS/FETCH_INTERVENTION_FAILURE';
